import { render, staticRenderFns } from "./CreateTariff.vue?vue&type=template&id=19a9c385"
import script from "./CreateTariff.vue?vue&type=script&lang=js"
export * from "./CreateTariff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports